// Remove this file during sign_core_2025_12_08_white_labeling_swap FF cleanup

import type { WhiteLabelStyles } from 'signer-app';

export const whiteLabelingOld = {
  page_background_color: '#f7f8f9',
  header_background_color: '#1a1a1a',
  text_color1: '#808080',
  text_color2: '#ffffff',
  link_color: '#0061FE',
  primary_button_color: '#0061FE',
  primary_button_text_color: '#ffffff',
  primary_button_color_hover: '#0061FE',
  primary_button_text_color_hover: '#ffffff',
  secondary_button_color: '#ffffff',
  secondary_button_text_color: '#0061FE',
  secondary_button_color_hover: '#ffffff',
  secondary_button_text_color_hover: '#0061FE',
  legal_version: 'terms1',
} as const;

export type WhiteLabelingPropertyIdOld = keyof typeof whiteLabelingOld;

export function oldWhiteLabelingToStyles(
  old: typeof whiteLabelingOld,
): WhiteLabelStyles {
  return {
    headerBackgroundColor: old.header_background_color,
    legalVersion: old.legal_version,
    linkColor: old.link_color,
    pageBackgroundColor: old.page_background_color,
    primaryButtonColor: old.primary_button_color,
    primaryButtonColorHover: old.primary_button_color_hover,
    primaryButtonTextColor: old.primary_button_text_color,
    primaryButtonTextColorHover: old.primary_button_text_color_hover,
    secondaryButtonColor: old.secondary_button_color,
    secondaryButtonColorHover: old.secondary_button_color_hover,
    secondaryButtonTextColor: old.secondary_button_text_color,
    secondaryButtonTextColorHover: old.secondary_button_text_color_hover,
    textColor1: old.text_color1,
    textColor2: old.text_color2,
  };
}

export function stylesToOldWhiteLabeling(
  styles: WhiteLabelStyles,
): typeof whiteLabelingOld {
  return {
    page_background_color: styles.pageBackgroundColor,
    header_background_color: styles.headerBackgroundColor,
    text_color1: styles.textColor1,
    text_color2: styles.textColor2,
    link_color: styles.linkColor,
    primary_button_color: styles.primaryButtonColor,
    primary_button_text_color: styles.primaryButtonTextColor,
    primary_button_color_hover: styles.primaryButtonColorHover,
    primary_button_text_color_hover: styles.primaryButtonTextColorHover,
    secondary_button_color: styles.secondaryButtonColor,
    secondary_button_text_color: styles.secondaryButtonTextColor,
    secondary_button_color_hover: styles.secondaryButtonColorHover,
    secondary_button_text_color_hover: styles.secondaryButtonTextColorHover,
    legal_version: styles.legalVersion,
  } as typeof whiteLabelingOld;
}
